import { render, staticRenderFns } from "./LoyaltyDiscounts.vue?vue&type=template&id=70aba2da&scoped=true&"
import script from "./LoyaltyDiscounts.vue?vue&type=script&lang=js&"
export * from "./LoyaltyDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyDiscounts.vue?vue&type=style&index=0&id=70aba2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aba2da",
  null
  
)

export default component.exports